import axios from 'axios';

export class PasswordService {
  updatePassword = body => {
    return axios.post('/passwd', body);
  };
}

export default new PasswordService();
